const translations = {
  fr: {
    commonNotifs: {
      notifications: 'Alertes',
      readAll: 'Tout marquer comme lu',
      deleteAll: 'Tout supprimer',
    },
  },
  en: {
    commonNotifs: {
      notifications: 'Notifications',
      readAll: 'Mark all as read',
      deleteAll: 'Clear all',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/common/modules/ui/i18n/commonNotifs.js